import NewProTierRebrand from '@/assets/image/free-to-pay/new-pro-tier-svg/new-pro-tier-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const NewProTierSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'new pro tier', ...rest } = props;

  return <Image src={NewProTierRebrand} alt={alt} {...rest} />;
};
